import SimpleType from "sap/ui/model/SimpleType";
import ValidateException from "sap/ui/model/ValidateException";

/**
 * @extends sap.ui.model.SimpleType
 * @namespace com.unitrade.crm.types
 */
export default class EmailType extends SimpleType {
  formatValue(sValue: string) {
    return sValue;
  }
  parseValue(vValue: any) {
    return vValue;
  }

  validateValue(vValue: string): void | Promise<undefined> {
    if (vValue) {
      const rexMail = /^\w+[\w-+.]*@\w+([-.]\w+)*\.[a-zA-Z]{2,}$/;
      if (!vValue.match(rexMail)) {
        throw new ValidateException("'" + vValue + "' ist keine gültige E-Mail Adresse.");
      }
    }
  }
}
